// Copyright (c) 2021 WiseTime. All rights reserved.

import { concat, Observable, of } from "rxjs"
import * as Actions from "../actions"
import * as Slice from "../slice"
import { Action } from "redux"
import { catchError, filter, mergeMap } from "rxjs/operators"
import {
  AckNotificationRequest,
  AckNotificationResponse,
} from "../../../generated/wisetime/user/notification/v4/notification_pb"
import { grpc } from "../../../app/rpc/executor"
import { notificationServiceClient } from "../../../app/rpc/client"

type ListNotificationsRpc = (requst: AckNotificationRequest) => Observable<AckNotificationResponse>

export const ackNotification = (ackNotificationRpc: ListNotificationsRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.ackNotification.match),
      mergeMap(action => of(action.payload).pipe(
        mergeMap(ackNotificationRpc),
        mergeMap(response => {
          const actions: Action[] = [
            Slice.removeNotification(action.payload.getNotificationId()),
          ]
          const url = response.getOpenUrl()
          if (url) {
            actions.push(Actions.redirectToUrl(url))
          }
          return concat(actions)
        }),
        catchError(_ => of(Actions.ackNotificationFailed())),
      )),
    )

const ackNotificationRpc = (requst: AckNotificationRequest): Observable<AckNotificationResponse> => (
  grpc(() => notificationServiceClient.ackNotification(requst, null))
)

export default ackNotification(ackNotificationRpc)
